import script from "./Step3Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3Summary.vue?vue&type=script&setup=true&lang=js"

import "./Step3Summary.vue?vue&type=style&index=0&id=6f9c6125&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9c6125"]])

export default __exports__